<template>
    <div class="providerSection">
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiFolderPlus }}
            </v-icon>
            <span>New Provider</span>
        </h1>
        <v-card
            class="docInfoBody"
            elevation="10"
            style="margin: 2% auto 0 auto; position: relative;"
        >
            <v-btn
                color="error"
                text
                outlined
                x-small
                style="position: absolute; right: 30px; top: 10px;"
                @click="resetField"
            >
                Clear Fields
            </v-btn>
            <v-form
                ref="form"
                v-model="valid"
                @submit.prevent="validate"
            >
                <v-autocomplete
                    ref="name"
                    v-model.trim="provider.name"
                    clearable
                    color="green accent-4"
                    autocomplete="nope"
                    :rules="rule.providerName"
                    :items="combinedItems"
                    label="Hospital/Clinic Name"
                    item-text="combinedText"
                    :item-style="{ height: '30px' }"
                    return-object
                    required
                    @keyup.enter="validate"
                >
                    <template #selection="data">
                        {{ data.item.hosp_name }}
                    </template>
                    <template #item="data">
                        <v-chip class="white--text" color="teal darken-1" style="margin: 3px 5px 0 0;">
                            {{ data.item.hosp_msu_code }}
                        </v-chip>{{ data.item.hosp_name }}
                    </template>
                </v-autocomplete>
                <v-text-field
                    ref="msuCode"
                    v-model.trim="provider.msuCode"
                    disabled
                    color="green accent-4"
                    :rules="rule.msuCode"
                    label="MSU Code"
                    required
                    autocomplete="nope"
                />
                <v-text-field
                    ref="email"
                    v-model.trim="provider.email"
                    color="green accent-4"
                    :rules="rule.email"
                    type="email"
                    label="Hospital/Clinic E-mail"
                    required
                    autocomplete="nope"
                />
                <v-text-field
                    ref="picName"
                    v-model.trim="provider.picName"
                    color="green accent-4"
                    :rules="rule.picName"
                    label="Person in Charge Name"
                    required
                    autocomplete="nope"
                />
                <v-text-field
                    ref="picNumber"
                    v-model.trim="provider.picNumber"
                    color="green accent-4"
                    :rules="rule.picNumber"
                    label="Person in Charge Contact Number"
                    required
                    autocomplete="nope"
                />
                <v-btn
                    :disabled="!valid"
                    color="green accent-4 white--text"
                    class="mr-4"
                    type="submit"
                >
                    Create
                </v-btn>
            </v-form>
            <v-snackbar
                v-if="provider.status.val"
                v-model="snackbar"
                :timeout="timeout"
                :color="provider.status.code === 201 ? 'green' : 'red'"
            >
                {{ provider.status.message }}
            </v-snackbar>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiFolderPlus
} from '@mdi/js'
export default {
    data: ()=>({
        mdiFolderPlus,
        screen_width: document.documentElement.clientWidth + 9,
        valid: false,
        provider: {
            name: null,
            email: null,
            picName: null,
            picNumber: null,
            msuCode: null,
            adminPasskey: null,
            status: {
                val: false,
                message: '',
                code: 0
            },
            showPass: false
        },
        rule: {
            providerName: [v => !!v || 'Hospital/Clinic is required'],
            email: [v => !!v || 'Hospital/Clinic E-mail is required', (v) => /^[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) || 'Hospital/Clinic E-mail must be valid', (v) => (v && v.length <= 50) || 'For Hospital/Clinic E-mail, please keep it under 50 characters'],
            picName: [v => !!v || 'Person in Charge Name is required', (v) => (v && v.length <= 60) || 'For Person in Charge Name, please keep it under 60 characters'],
            picNumber: [v => !!v || 'Person in Charge Contact Number is required'],
            msuCode: [v => !!v || 'MSU Code is required', (v) => (v && v.length <= 10) || 'For MSU Code, please keep it under 10 characters']

        },
        snackbar: false,
        timeout: 4000,
        nameRule: [v=>/^[a-zA-Z\s'-\.]*$/.test(v)||'Please only use letters, hyphens (-), apostrophes (\'), periods (.), and spaces.']
    }),
    computed: {
        ...mapGetters(['signupProviderData', 'fetchProvidersData']),
        combinedItems() {
            if (!this.fetchProvidersData || !this.fetchProvidersData.data) return []
            return this.fetchProvidersData.data.map(item => ({
                ...item,
                combinedText: `${item.hosp_msu_code} ${item.hosp_name}`
            }))
        }
    },
    watch: {
        'provider.name': {
            handler(newVal) {
                if (newVal) {
                    this.provider.msuCode = this.provider.name.hosp_msu_code
                } else {
                    this.provider.msuCode = null
                }
            }
        },
        signupProviderData(newVal) {
            if (newVal) {
                this.provider.status.val        = true
                this.provider.status.message    = newVal.state
                this.provider.status.code       = newVal.status
                this.snackbar                   = true
            }
        }
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    async created() {
        // await this.getCsrfToken()
        this.fetchProviders()
    },
    methods: {
        ...mapActions(['getCsrfToken', 'createProvider', 'signupProvider', 'fetchProviders']),
        resetField() {
            this.$refs.form.reset()
        },
        toTitleCase(str) {
            return str.toUpperCase()
        },
        async validate () {
            if (this.$refs.form.validate()) {
                const arg = {
                    PROV_NAME: String(this.provider.name.hosp_name).toUpperCase(),
                    EMAIL: this.provider.email,
                    PIC_NAME: this.toTitleCase(this.provider.picName),
                    PIC_CPNO: this.provider.picNumber,
                    MSU_CODE: this.provider.msuCode
                }
                await this.signupProvider(arg)
            }
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 5%;
    padding: 3%;
}
</style>
